/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import type {
  InputDescription,
  IntegrationDescription,
  TestTriggerEditorOption,
} from "@smartsuite/automation-engine-api";
import { Text } from "@smartsuite/react-ui/lib";
import { observer } from "mobx-react-lite";
import { StyledContainerWrapper } from "../../../style";
import type {
  InputCandidate,
  TriggerCandidate,
} from "../../../../../../../../types/candidate";
import { useRootStore } from "../../../../../../../../stores/hooks";
import { useEngineClient } from "../../../../../../../../services/engineClient";
import { useEffect, useState } from "react";
import * as S from "./style";
import { RequestList } from "./request-list";
import { updateTriggerDescription } from "../../../../../../../../services/updateDescription";
import { translateIfPresent } from "../../../../../../../../locales/i18n";

export const TestTriggerEditor = observer<{
  input: InputCandidate;
  onChange: (input: InputCandidate) => void;
  integrations: IntegrationDescription[];
  trigger?: TriggerCandidate;
  onClickTrash?: () => void;
  description?: InputDescription;
}>(({ input, onChange, integrations, trigger, description, onClickTrash }) => {
  const store = useRootStore();
  const engineClient = useEngineClient();

  const {
    automations: { candidate },
  } = store;

  const [options, setOptions] = useState<TestTriggerEditorOption[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (description?.editor?.editor.oneofKind === "testTrigger") {
      setOptions(description?.editor.editor.testTrigger.options);
    }
  }, [description, input]);

  const onRefresh = (): void => {
    setLoading(true);
    void updateTriggerDescription(
      candidate,
      false,
      engineClient,
      store.automations,
      store.integrations,
    ).finally(() => {
      setLoading(false);
    });
  };

  const onUseValue = (value: string): void => {
    onChange({
      ...input,
      value: {
        values: [
          {
            value: {
              oneofKind: "string",
              string: value,
            },
          },
        ],
      },
    });
    onRefresh();
  };

  return (
    <StyledContainerWrapper>
      <S.StyledContent>
        <Text>
          {translateIfPresent(
            "triggers.Successful requests will receive a success response.",
            "If the request is successful, you should receive a response of {success: true}.",
          )}
        </Text>
        <Text className="li">
          {translateIfPresent(
            "triggers.Requests received when the Webhook is off will initiate a new test run.",
            "Requests received when the Webhook is off will initiate a new test run.",
          )}
        </Text>
        <Text className="li">
          {translateIfPresent(
            "triggers.Requests received when the Webhook is on will trigger the automation's actions.",
            "Requests received when the Webhook is on will trigger the automation's actions.",
          )}
        </Text>
      </S.StyledContent>
      <RequestList
        onChange={onUseValue}
        onRefresh={onRefresh}
        options={options}
        loading={loading}
        integrationId={trigger?.triggerReference?.integrationId ?? ""}
        timezone={candidate.getTimezone()}
      />
    </StyledContainerWrapper>
  );
});
